import { FieldType } from '@pmp/api';
import { CrudMode, FormItem, SelectsOptions } from '@ohpen/enso-ui';
import { HALF_WIDTH, crudSection } from '@pmp/utils';

export const getExchangeRatesSchema = (selectsOptions: SelectsOptions, mode?: CrudMode | null): FormItem[] => [
  crudSection('global.labels.details', mode, [
    {
      title: 'pmp.exchangeRates.labels.sourceCurrency',
      dataIndex: 'sourceCurrency',
      colProps: HALF_WIDTH,
      valueType: 'select',
      formItemProps: {
        required: true,
      },
      fieldProps: {
        options: selectsOptions[FieldType.SOURCE_CURRENCY],
        disabled: mode === CrudMode.VIEW || mode === CrudMode.EDIT,
        showSearch: true,
      },
    },
    {
      title: 'pmp.exchangeRates.labels.targetCurrency',
      dataIndex: 'targetCurrency',
      colProps: HALF_WIDTH,
      valueType: 'select',
      formItemProps: {
        required: true,
      },
      fieldProps: {
        options: selectsOptions[FieldType.TARGET_CURRENCY],
        disabled: true,
      },
    },
    {
      title: 'pmp.exchangeRates.labels.rate',
      dataIndex: 'rate',
      colProps: HALF_WIDTH,
      valueType: 'digit',
      formItemProps: {
        required: true,
      },
      fieldProps: {
        disabled: mode === CrudMode.VIEW,
      },
    },
  ]),
  crudSection('global.labels.validity', mode, [
    {
      title: 'pmp.exchangeRates.labels.startDate',
      dataIndex: 'startDate',
      colProps: HALF_WIDTH,
      valueType: 'date',
      formItemProps: {
        required: true,
      },
      fieldProps: {
        disabled: mode === CrudMode.VIEW,
      },
    },
  ]),
];
